import React, { useEffect, useState } from 'react';
import { setWin as markWin, GIFT_BAG, GIFT_VOUCHER } from '../api/campaign';
import bagImg from '../img/bag.png';
import voucherImg from '../img/voucher.jpg';

export default function Status({ state="win", b, userId, giftType=null }) {
    // Campaign 2 prizes. Campaign 1's mobile reload is not used this time.
    const gift = giftType === GIFT_VOUCHER
        ? { img: voucherImg, name: 'Cargills Voucher', note: 'Show this screen to the promoter to collect your voucher.' }
        : giftType === GIFT_BAG
            ? { img: bagImg, name: 'Cross Body Bag', note: 'Show this screen to the promoter to collect your bag.' }
            : null;
    const [showContent, setShowContent] = useState(false);
    const [confettiPieces, setConfettiPieces] = useState([]);

    // Color palette based on brand
    const colors = b === 2 ? {
        bgFrom: '#8B2500',
        bgVia: '#C4621F',
        bgTo: '#E87722',
        primary: '#F59E42',
        primaryLight: '#FFA94D',
        glow: 'rgba(245, 158, 66, 0.2)',
        confettiColors: ['#F59E42', '#FFA94D', '#FB923C', '#FDBA74', '#FED7AA']
    } : {
        bgFrom: '#1A0D2E',
        bgVia: '#5D1A5E',
        bgTo: '#B81F7B',
        primary: '#EC4899',
        primaryLight: '#F472B6',
        glow: 'rgba(236, 72, 153, 0.2)',
        confettiColors: ['#EC4899', '#F472B6', '#A855F7', '#F59E0B', '#10B981']
    };

    const setWin =async(id)=>{
        try {
            await markWin(id, giftType);
        } catch (err) {
            console.error("error saving win: ", err);
        }
    };

    useEffect(() => {
        setTimeout(() => setShowContent(true), 300);

        if (state === "win") {
            const pieces = Array.from({ length: 50 }, (_, i) => ({
                id: i,
                left: Math.random() * 100,
                delay: Math.random() * 2,
                duration: 3 + Math.random() * 2,
                color: colors.confettiColors[Math.floor(Math.random() * colors.confettiColors.length)]
            }));
            setConfettiPieces(pieces);
            setWin(userId);
        }

        // const timerId = setTimeout(() => window.location.reload(), 8000);
        // return () => clearTimeout(timerId);
    }, [state]);

    return (
        <div 
            className='flex flex-col items-center justify-center w-full min-h-screen relative overflow-hidden px-6'
            style={{ background: `linear-gradient(to bottom right, ${colors.bgFrom}, ${colors.bgVia}, ${colors.bgTo})` }}
        >
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-20 left-10 w-32 h-32 rounded-full blur-3xl animate-pulse" style={{ backgroundColor: colors.glow }}></div>
                <div className="absolute bottom-20 right-10 w-40 h-40 rounded-full blur-3xl animate-pulse" style={{ backgroundColor: colors.glow, animationDelay: '1s' }}></div>
            </div>

            {state === "win" && confettiPieces.map((piece) => (
                <div key={piece.id} className="absolute w-3 h-3 animate-confetti" style={{ left: `${piece.left}%`, top: '-10px', backgroundColor: piece.color, animationDelay: `${piece.delay}s`, animationDuration: `${piece.duration}s`, borderRadius: Math.random() > 0.5 ? '50%' : '0' }}></div>
            ))}

            <div className={`relative z-10 max-w-md w-full transition-all duration-1000 ${showContent ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}>
                {state === "win" && (
                    <div className="text-center space-y-6">
                        <div className="flex justify-center mb-6">
                            <div className="relative animate-bounce-in">
                                <div className="absolute inset-0 rounded-full blur-3xl animate-pulse-fast" style={{ backgroundColor: `${colors.primary}40` }}></div>
                                <div className="relative bg-gradient-to-br from-yellow-300 to-yellow-500 rounded-full p-8 shadow-2xl border-4 border-yellow-200 animate-rotate-slow">
                                    <span className="text-7xl animate-bounce-subtle">🏆</span>
                                </div>
                                <div className="absolute -top-2 -left-2 text-3xl animate-sparkle">✨</div>
                                <div className="absolute -top-2 -right-2 text-3xl animate-sparkle" style={{ animationDelay: '0.5s' }}>✨</div>
                                <div className="absolute -bottom-2 -left-2 text-3xl animate-sparkle" style={{ animationDelay: '1s' }}>⭐</div>
                                <div className="absolute -bottom-2 -right-2 text-3xl animate-sparkle" style={{ animationDelay: '1.5s' }}>⭐</div>
                            </div>
                        </div>

                        <div className="space-y-3 animate-slide-up">
                            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 shadow-2xl border-2" style={{ borderColor: `${colors.primary}50` }}>
                                <div className="relative inline-block">
                                    <div className="absolute inset-0 blur-xl opacity-50" style={{ background: `linear-gradient(to right, ${colors.primary}, ${colors.primaryLight})` }}></div>
                                    <h2 className="relative text-3xl font-black bg-gradient-to-r bg-clip-text text-transparent animate-gradient-shift" style={{ backgroundImage: `linear-gradient(to right, ${colors.primary}, #FDE047, ${colors.primaryLight})`, backgroundSize: '200% 200%' }}>
                                        Congratulations you Won!
                                    </h2>
                                </div>
                                <div className="text-6xl mt-6 animate-bounce-in" style={{ animationDelay: '0.3s' }}>🎊 🎉 🎊</div>
                            </div>

                            {/* The prize itself: cross body bag or Cargills voucher. */}
                            {gift && (
                                <div
                                    className="backdrop-blur-sm rounded-2xl p-6 shadow-xl border animate-slide-up"
                                    style={{ background: `linear-gradient(to right, ${colors.primary}30, ${colors.primaryLight}30)`, borderColor: `${colors.primary}50`, animationDelay: '0.5s' }}
                                >
                                    <p className="text-white/80 text-sm uppercase tracking-wider mb-3">You have won</p>
                                    <div className="bg-white/95 rounded-2xl p-4 shadow-inner">
                                        <img
                                            src={gift.img}
                                            alt={gift.name}
                                            className="mx-auto h-40 w-auto object-contain animate-bounce-in"
                                            style={{ animationDelay: '0.7s' }}
                                        />
                                    </div>
                                    <p className="text-white text-2xl font-bold mt-4">{gift.name}</p>
                                    <p className="text-white/90 text-sm mt-2">{gift.note}</p>
                                </div>
                            )}

                            {/* CAMPAIGN 2 IS ATLAS ONLY -- the Innovate reload message is
                                switched off. Campaign 1 showed, for b === 1:
                                "Your reload is coming to your mobile shortly!"
                                and for b === 2: "Show this to an assistant nearby". */}
                            {!gift && (
                                <div className="backdrop-blur-sm rounded-2xl p-6 shadow-xl border animate-slide-up" style={{ background: `linear-gradient(to right, ${colors.primary}30, ${colors.primaryLight}30)`, borderColor: `${colors.primary}50`, animationDelay: '0.5s' }}>
                                    <p className="text-white text-lg font-medium">Show this to an assistant nearby</p>
                                </div>
                            )}
                        </div>

                        <div className="flex justify-center gap-4 text-4xl animate-wave">
                            <span className="animate-bounce" style={{ animationDelay: '0s' }}>🎈</span>
                            <span className="animate-bounce" style={{ animationDelay: '0.1s' }}>🎊</span>
                            <span className="animate-bounce" style={{ animationDelay: '0.2s' }}>🎉</span>
                            <span className="animate-bounce" style={{ animationDelay: '0.3s' }}>🎊</span>
                            <span className="animate-bounce" style={{ animationDelay: '0.4s' }}>🎈</span>
                        </div>
                    </div>
                )}

                {state === "lost" && (
                    <div className="text-center space-y-6">
                        <div className="flex justify-center mb-6">
                            <div className="relative animate-bounce-in">
                                <div className="absolute inset-0 rounded-full blur-3xl animate-pulse" style={{ backgroundColor: `${colors.primary}40` }}></div>
                                <div className="relative rounded-full p-8 shadow-2xl border-4" style={{ background: `linear-gradient(to bottom right, ${colors.primary}, ${colors.primaryLight})`, borderColor: colors.primaryLight }}>
                                    <span className="text-7xl animate-heartbeat">💖</span>
                                </div>
                                <div className="absolute -top-2 -left-2 text-2xl animate-twinkle">⭐</div>
                                <div className="absolute -top-2 -right-2 text-2xl animate-twinkle" style={{ animationDelay: '0.5s' }}>⭐</div>
                                <div className="absolute -bottom-2 -left-2 text-2xl animate-twinkle" style={{ animationDelay: '1s' }}>✨</div>
                                <div className="absolute -bottom-2 -right-2 text-2xl animate-twinkle" style={{ animationDelay: '1.5s' }}>✨</div>
                            </div>
                        </div>

                        <div className="space-y-4 animate-slide-up">
                            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 shadow-2xl border-2" style={{ borderColor: `${colors.primary}50` }}>
                                <h1 className="text-4xl font-bold text-white drop-shadow-xl">Thank you participating!</h1>
                            </div>

                            {/* CAMPAIGN 2 IS ATLAS ONLY -- Innovate's raffle-draw line is
                                switched off. Campaign 1 showed, for b === 1:
                                "You will entring to the main raffle draw". There is no
                                raffle this run; prizes are instant win only. */}
                            <div className="backdrop-blur-sm rounded-2xl p-6 shadow-xl border animate-slide-up" style={{ background: `linear-gradient(to right, ${colors.primary}30, ${colors.primaryLight}30)`, borderColor: `${colors.primary}50`, animationDelay: '0.3s' }}>
                                <p className="text-white text-lg font-medium">Better luck next time!</p>
                            </div>
                        </div>
                    </div>
                )}

                {/* <div className="mt-8 text-center animate-fade-in" style={{ animationDelay: '1s' }}>
                    <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full border border-white/20">
                        <div className="w-2 h-2 rounded-full animate-ping" style={{ backgroundColor: colors.primary }}></div>
                        <span className="text-white/80 text-sm">Redirecting shortly...</span>
                    </div>
                </div> */}
            </div>

            <style jsx>{`
                @keyframes confetti { 0% { transform: translateY(-10px) rotate(0deg); opacity: 1; } 100% { transform: translateY(100vh) rotate(720deg); opacity: 0; } }
                @keyframes bounce-in { 0% { transform: scale(0); opacity: 0; } 50% { transform: scale(1.2); } 100% { transform: scale(1); opacity: 1; } }
                @keyframes slide-up { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
                @keyframes gradient-shift { 0%, 100% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } }
                @keyframes sparkle { 0%, 100% { opacity: 1; transform: scale(1) rotate(0deg); } 50% { opacity: 0.5; transform: scale(1.5) rotate(180deg); } }
                @keyframes heartbeat { 0%, 100% { transform: scale(1); } 25% { transform: scale(1.1); } 50% { transform: scale(1); } 75% { transform: scale(1.05); } }
                @keyframes twinkle { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.3; transform: scale(0.8); } }
                @keyframes pulse-fast { 0%, 100% { opacity: 0.4; } 50% { opacity: 0.8; } }
                @keyframes rotate-slow { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
                @keyframes bounce-subtle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
                @keyframes wave { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
                @keyframes fade-in { from { opacity: 0; } to { opacity: 1; } }
                .animate-confetti { animation: confetti linear forwards; }
                .animate-bounce-in { animation: bounce-in 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards; }
                .animate-slide-up { animation: slide-up 0.6s ease-out forwards; }
                .animate-gradient-shift { background-size: 200% 200%; animation: gradient-shift 3s ease infinite; }
                .animate-sparkle { animation: sparkle 2s ease-in-out infinite; }
                .animate-heartbeat { animation: heartbeat 1.5s ease-in-out infinite; }
                .animate-twinkle { animation: twinkle 2s ease-in-out infinite; }
                .animate-pulse-fast { animation: pulse-fast 1s ease-in-out infinite; }
                .animate-rotate-slow { animation: rotate-slow 20s linear infinite; }
                .animate-bounce-subtle { animation: bounce-subtle 2s ease-in-out infinite; }
                .animate-wave { animation: wave 2s ease-in-out infinite; }
                .animate-fade-in { animation: fade-in 0.8s ease-out forwards; }
            `}</style>
        </div>
    );
}